import React from "react";
import { useNavigate } from "../../hooks/useRouter";
import "./VideoTutorials.css";

// components
import { useConstants } from "../../constant/constantProvider";
import { useAccessibleApps } from "../../hooks/useAccessibleApps";
import { RBAC_APPS } from "../../constant/rbacConfig";

//assets
import image from "../../assets/images/thumbnail.svg";
import arrowIcon from "../../assets/new-images/up-arrow-icon.svg";

const VideoTutorials = () => {
  const navigate = useNavigate();
  const { TUTORIAL_VIDEOS, INTRO_TITLE, CHAT_GUIDE_TITLE, CUSTOM_ASSISTANT_TITLE, CHAT_WITH_DOCS_TITLE } = useConstants();
  const { accessibleApps } = useAccessibleApps();

  const videos = [
    {
      title: INTRO_TITLE,
      time: "02:23",
      thumbnail: image,
      url: "https://upllimited.sharepoint.com/:v:/s/CDTCommunicationPortal/EUrf55B5pqlDos-kPfTR_wMBbh4kgE9wHHxNickCelMPDQ?e=WfuUl4",
    },
    {
      title: CHAT_GUIDE_TITLE,
      time: "01:59",
      thumbnail: image,
      url: "https://upllimited.sharepoint.com/:v:/s/CDTCommunicationPortal/EfyuwDdNuOxKl620eKQAnRcB4yMp33ToTEK2P1r1Gn8gqA?e=flLSGj",
    },
    {
      title: CUSTOM_ASSISTANT_TITLE,
      url: "https://upllimited.sharepoint.com/sites/CDTCommunicationPortal/_layouts/15/stream.aspx?id=%2Fsites%2FCDTCommunicationPortal%2FShared%20Documents%2FVideos%2FUPLGenie%2FUPL%20Genie%20Custom%20Assistant%2Emp4&ga=1&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E2f038435%2Deccc%2D426e%2Db493%2Df52dd9de583e",
      time: "02:51",
      thumbnail: image,
    },
    {
      title: CHAT_WITH_DOCS_TITLE,
      url: "https://upllimited.sharepoint.com/sites/CDTCommunicationPortal/Shared%20Documents/Videos/UPLGenie/UPL%20Genie%20Chat%20With%20Documents.mp4?web=1",
      time: "01:38",
      thumbnail: image,
    },
  ];

  const handleGoToApp = () => {
    const chatGenie = accessibleApps.find(app => app.rbacKey === RBAC_APPS.CHAT_GENIE);
    const target = chatGenie || accessibleApps[0];
    if (target) navigate(target.path);
  };

  return (
    <div className="video-container">
      <div className="video-header-centered">
        <div className="video-top-row">
          <button className="button-style back-icon" onClick={handleGoToApp} type="button">
            <img
              src={arrowIcon}
              alt="back"
              className="heading-arrow-icon"
            />
          </button>
          <h1 className="video-main-title">{TUTORIAL_VIDEOS}</h1>
          <div className="spacer"></div>
        </div>
      </div>
      <div className="video-tutorials-container">
        <div className="video-tutorials-grid">
          {videos.map((video, index) => (
            <div key={index} className="video-tutorial-item">
              <a
                href={video.url}
                target="_blank"
                rel="noopener noreferrer"
                className="video-thumbnail-container"
              >
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="video-thumbnail"
                />
                <div className="video-play-overlay">
                  <div className="play-icon-circle">
                    <div className="play-triangle"></div>
                  </div>
                </div>
                <span className="video-duration-badge">{video.time}</span>
              </a>
              <p className="video-title">{video.title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoTutorials;
